// app/axiosInstance.js
import axios from 'axios';
import { API_URL } from 'config/config';

const getAuth = () => {
  return localStorage.getItem('token');
};
const downloadAxiosInstance = axios.create({
  baseURL: API_URL || undefined, // Replace with your API base URL
  timeout: 10000, // Optional: set a timeout for requests
  headers: {
    'Content-Type': 'application/json',
    Authorization: getAuth(),
    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    // Add any other headers you need
  },
});
downloadAxiosInstance.interceptors.request.use(function (config) {
  const token = getAuth();
  config.headers['Authorization'] = token;
  config.headers['Accept'] =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  return config;
});

export default downloadAxiosInstance;
